import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { shippingSkipPackingOptions, shippingSkipPackingValues } from './constants'

const ShippingSkipPackingSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Pantalla de empaquetado')}
      menuItems={shippingSkipPackingOptions.map(option => ({ ...option, label: t(option.label) }))}
      value={value ? shippingSkipPackingValues.skip : shippingSkipPackingValues.pack}
      handleChange={e => onChange('shipping_skip_packing', e.target.value === shippingSkipPackingValues.skip)}
      fullWidth
    />
  )
}

export default ShippingSkipPackingSelector
